import React, { useState } from "react";
import {
    Box, Typography, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, TablePagination, Button, useMediaQuery
} from "@mui/material";

const MS_COLORS = {
    primary: '#2D4A3D',
    primaryLight: '#EBF5EE',
    text: '#323130',
    textSecondary: '#605D5C',
    background: '#FFFFFF',
    backgroundLight: '#F3F2F1',
    border: '#E1E1E1',
    hoverBackground: '#F0F0F0',
    white: '#FFFFFF',
    accent: '#107C10',
    red: '#D83B01',
};

// Component now receives `activities` as a prop
const AccountabilityManagement = ({ activities }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const isSmallScreen = useMediaQuery("(max-width:600px)");

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const displayedActivities = activities.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const openFileInNewTab = (fileUrl) => {
        window.open(fileUrl, '_blank');
    };

    const noActivities = activities.length === 0;

    return (
        <Box sx={{ backgroundColor: "#fff", borderRadius: "16px", boxShadow: "0 2px 16px rgba(0,0,0,0.06)", border: "1px solid rgba(0,0,0,0.05)", p: 3, mt: 4 }}>
            <Typography variant="h6" sx={{ color: "#1a1a2e", mb: 3, fontWeight: 800, fontSize: isSmallScreen ? "1.05rem" : "1.2rem", letterSpacing: "-0.3px" }}>
                Accountability Activities
            </Typography>

            {noActivities ? (
                <Box sx={{ textAlign: "center", color: MS_COLORS.textSecondary, mt: 4, mb: 4, fontSize: "0.9rem", p: 3, border: `1px dashed ${MS_COLORS.border}`, borderRadius: 1, bgcolor: MS_COLORS.backgroundLight }}>
                    <Typography variant="body1">
                        No accountability activities available.
                    </Typography>
                </Box>
            ) : (
                <>
                    <TableContainer component={Paper} sx={{ borderRadius: 1, boxShadow: 0, overflowX: "auto", border: `1px solid ${MS_COLORS.border}` }}>
                        <Table sx={{ minWidth: 700 }}>
                            <TableHead sx={{ bgcolor: MS_COLORS.backgroundLight }}>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: "bold", fontSize: "0.85rem", whiteSpace: "nowrap", color: MS_COLORS.text }}>Campaign Name</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", fontSize: "0.85rem", whiteSpace: "nowrap", color: MS_COLORS.text }}>User Name</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", fontSize: "0.85rem", whiteSpace: "nowrap", color: MS_COLORS.text }}>Message</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", fontSize: "0.85rem", whiteSpace: "nowrap", color: MS_COLORS.text }}>File</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", fontSize: "0.85rem", whiteSpace: "nowrap", color: MS_COLORS.text }}>Date</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {displayedActivities.map((activity) => (
                                    <TableRow key={activity.id} sx={{ "&:last-child td, &:last-child th": { border: 0 }, "&:hover": { backgroundColor: MS_COLORS.hoverBackground } }}>
                                        <TableCell sx={{ fontSize: "0.8rem", color: MS_COLORS.textSecondary, whiteSpace: "nowrap" }}>{activity.campaign_name}</TableCell>
                                        <TableCell sx={{ fontSize: "0.8rem", color: MS_COLORS.textSecondary, whiteSpace: "nowrap" }}>{activity.user_name}</TableCell>
                                        <TableCell sx={{ fontSize: "0.8rem", color: MS_COLORS.textSecondary, maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis' }}>{activity.message}</TableCell>
                                        <TableCell sx={{ fontSize: "0.8rem" }}>
                                            {activity.file_url ? (
                                                <Button variant="outlined" size="small" onClick={() => openFileInNewTab(activity.file_url)} sx={{ textTransform: 'none', fontSize: '0.75rem', borderRadius: '4px', borderColor: MS_COLORS.primary, color: MS_COLORS.primary, '&:hover': { backgroundColor: MS_COLORS.primaryLight + '30', borderColor: MS_COLORS.primary } }}>
                                                    View File
                                                </Button>
                                            ) : (
                                                <Typography sx={{ fontSize: '0.75rem', color: MS_COLORS.textSecondary }}>N/A</Typography>
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ fontSize: "0.8rem", color: MS_COLORS.textSecondary, whiteSpace: "nowrap" }}>{new Date(activity.created_at).toLocaleString()}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={activities.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{ "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select, & .MuiTablePagination-actions": { fontSize: "0.8rem", color: MS_COLORS.textSecondary } }}
                    />
                </>
            )}
        </Box>
    );
};

export default AccountabilityManagement;